import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";
import { TryOn } from "../../components/TryOn";

export const HomeTryOn = ({ tryOnBtn, hasBg } = {}) => {
  const { t } = useTranslation();
  return (
    <div className={hasBg ? "home-try-on has-bg-style" : "home-try-on"}>
      <div className="inner">
        <Title title={t("home.tryOn.title")} size="h1"></Title>
        <div className="descript">{t("home.tryOn.subtitle")}</div>
        {tryOnBtn || (
          <span data-log="try/signup">
            <TryOn style={{ justifyContent: "center" }} />
          </span>
        )}
      </div>
    </div>
  );
};
